import { Backdrop, Box, CircularProgress, Grid, Stack } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import NoDataFound from "../../CustomComponents/NoDataFound";

const DisbursementDetails = (props) => {
  const [loading, setLoading] = useState(false);
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#004A92",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const filterScreen = useSelector((state) => state.cov.filterScreen);

  const [disbursementList, setDisbursementList] = useState([]);
  const [cancelList, setCancelList] = useState([]);
  const [reSchedulementDetails, setReSchedulementDetails] = useState([]);
  const [disbursementFavourList, setDisbursementFavourList] = useState([]);

  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    getDisbursementData(appNum);
  }, []);

  const getDisbursementData = async (appNum) => {
    setLoading(true);
    const response = await axios.post(
      "/customerOneView/getDisbursementDetailData",
      {
        applicationNum: appNum,
      }
    );
    if (response.status === 200) {
      setDisbursementList(response.data.disbursementRequestList);
      setCancelList(response.data.disbursementHistoryList);
      setReSchedulementDetails(response.data.reSchedulementList);
      setDisbursementFavourList(response.data.disbursementFavourList);
      setLoading(false);
    }
  };

  const emptyData = (
    <Stack height="100%" alignItems="center" justifyContent="center">
      <NoDataFound message={"No Data"} />
    </Stack>
  );
  return (
    <>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </>
      )}
      <Box sx={{ marginTop: "1%", marginRight: "2%" }}>
        {disbursementList.length === 0 ? (
          emptyData
        ) : (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">
                    Disbursement Number
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Disbursement Amount (₹)
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Disbursement Date
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Rate of Interest (%)
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    Deduction Amount (₹)
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {disbursementList.map((row) => (
                  <StyledTableRow key={row.disbHeaderKey}>
                    <StyledTableCell align="right">
                      {row.disbNum}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {parseInt(row.totalDisbAmt).toLocaleString("en-IN")}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {new Date(row.dateOfDisb).toLocaleDateString("fr-FR")}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.rateOfInterest}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {parseInt(row.totalDeductionAmt).toLocaleString("en-IN")}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Grid container columnSpacing={2} marginTop={"0.8rem"}>
          <Grid item>
            <h4>Payment Details:</h4>
            {disbursementFavourList.length === 0 ? (
              emptyData
            ) : (
              <TableContainer component={Paper}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center">
                        Disbursement Number
                      </StyledTableCell>{" "}
                      <StyledTableCell align="center">
                        Cheque Number
                      </StyledTableCell>{" "}
                      <StyledTableCell align="center">
                        Cheque Favour Name
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Payment Mode
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {disbursementFavourList.map((row) => (
                      <StyledTableRow key={row.disbHeaderKey}>
                        <StyledTableCell align="right">
                          {row.disbNum}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.chequeNum ? row.chequeNum : "-"}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.accHoldrName ? row.accHoldrName : "-"}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {row.paymentMode ? row.paymentMode : "-"}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>

          <Grid item>
            {cancelList.length !== 0 && (
              <>
                <h4>Cancelled Disbursement Details:</h4>
                <TableContainer component={Paper}>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">
                          Disbursement Number
                        </StyledTableCell>{" "}
                        <StyledTableCell align="center">
                          Cancelled Date
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Cancelled By
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cancelList.map((rows) => (
                        <StyledTableRow key={rows.disbHeaderKey}>
                          <StyledTableCell align="right">
                            {rows.disbNum}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {new Date(rows.lastModifiedDate).toLocaleDateString(
                              "fr-FR"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {rows.lastModifiedBy}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </Grid>
        </Grid>

        <Grid container marginTop={"0.8rem"}>
          <Grid item>
            {reSchedulementDetails.length !== 0 && (
              <>
                <h4>ReSchedulement Details:</h4>
                <TableContainer component={Paper}>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">S.No</StyledTableCell>{" "}
                        <StyledTableCell align="center">
                          Effective Date
                        </StyledTableCell>{" "}
                        <StyledTableCell align="center">
                          Loan Balance (₹)
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Current EMI (₹)
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Revised EMI (₹)
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Current Tenure (Months)
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Revised Tenure (Months)
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Rate of Interest (%)
                        </StyledTableCell>
                        <StyledTableCell align="center">Reason</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {reSchedulementDetails.map((row, index) => (
                        <StyledTableRow key={row.reScheduleKey}>
                          <StyledTableCell align="right">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {new Date(row.effectiveDate).toLocaleDateString(
                              "fr-FR"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {parseInt(row.loanAmt).toLocaleString("en-IN")}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {parseInt(row.currentEmiAmt).toLocaleString(
                              "en-IN"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {parseInt(row.revisedEmiAmt).toLocaleString(
                              "en-IN"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.currentTenure}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.revisedTenure}
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {row.roi}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.reasonForReschedule}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default DisbursementDetails;
